import React from 'react'
import TimeCounter from "./TimeCounter/TimeCounter"
import { getAnalysisStatus, getAnalysisStatusColor } from "../../utils/utils"

function TimerBox (props) {
    let {operation} = props
    if(operation.analysis_status === "pending" || operation.analysis_status === "in_manual_analysis"){
        return (
            <TimeCounter timeCounter={operation}/>
        )
    }
    else{
        return(
            <div className="analysisCard" style={{height:"100%", borderWidth:"1px", borderStyle:"solid", borderColor:getAnalysisStatusColor(operation.analysis_status)}}>
                <div 
                    className={["normalText", "substitleSize", "bold"].join(" ")} 
                    style={{margin:"auto", color:getAnalysisStatusColor(operation.analysis_status)}}
                >
                    {getAnalysisStatus(operation.analysis_status)}                    
                </div>
            </div>
        )
    }
}

export default TimerBox